import React from "react";
import { Header } from "Components/DP/DPTable/DPTable";
import { DPTable, DPEmptyTable, DPComponentLoader } from "Components/DP";
import GrossEarningsTableRow from "../GrossEarningsTableRow/GrossEarningsTableRow";
import { useQuery } from "@apollo/client";
import queries from "Shared/queries";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { GetGrossEarningsTransmissionsFilesQuery, GetGrossEarningsTransmissionsFilesQueryVariables } from "generated/graphql";

const grossEarningsHeaders: Header[] = [
  "Date/Time",
  "Uploader",
  "File Name",
  "Status",
  "Submission",
];

const GrossEarningsTable = () => {
  const { permissions } = usePartnerConfig();

  const headers = permissions.canViewGrossEarnings
    ? grossEarningsHeaders
    : grossEarningsHeaders.filter(h => h !== "Submission");

  const [page, setPage] = React.useState(1);
  const rowsPerPage = parseInt(
    process.env.REACT_APP_DATA_EXCHANGE_PER_PAGE!,
    10
  );
  const { data, refetch, loading } = useQuery<
    GetGrossEarningsTransmissionsFilesQuery,
    GetGrossEarningsTransmissionsFilesQueryVariables
  >(
    queries.GET_GROSS_EARNINGS_TRANSMISSIONS_FILES_QUERY,
    {
      variables: {
        page,
        perPage: rowsPerPage,
      },
    }
  );
  const totalCount = data?.grossEarningsTransmissionFiles?.totalCount || 0;

  const onChangePageFn = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    setPage(page);
  };

  React.useEffect(() => {
    refetch({ page });
  }, [page, refetch]);

  return (
    <DPTable
      page={page}
      rowsPerPage={rowsPerPage}
      count={totalCount}
      headers={headers}
      onChangePage={onChangePageFn}
    >
      <DPComponentLoader
        isLoading={loading}
        kind={"table"}
        awaitComponent={
          data?.grossEarningsTransmissionFiles?.items.length ? (
            <>
              {data.grossEarningsTransmissionFiles.items.map(file => (
                <GrossEarningsTableRow key={file.id} {...file} />
              ))}
            </>
          ) : (
            <DPEmptyTable message={"Uploads will appear here once created"} />
          )
        }
      />
    </DPTable>
  );
};

export default GrossEarningsTable;
